import { FunctionComponent } from "react";
import '../../assets/styles.css';
import store from '../../utils/store'

interface ContainerProps {
    section: any
    parentTitle: string
}

const QuestionSection: FunctionComponent<ContainerProps> = (props) => {
    const s = props.section
    const parentTitle = props.parentTitle

    const runCallback = ( cb: any ) => {
        return cb();
    }

    const getCheckedBoxes = ( chkboxName: string ) => {
        let checkboxes = document.getElementsByName( chkboxName )
        let checkboxesChecked = []
        // loop over them all
        for ( let i=0; i<checkboxes.length; i++ ) {
           // And stick the checked ones onto an array...
           const checkEl = checkboxes[i] as HTMLInputElement
           if ( checkEl.checked ) {
              checkboxesChecked.push( checkEl.value )
           }
        }
        // Return the array if it is non-empty, or null
        return checkboxesChecked.length > 0 ? checkboxesChecked : null
    }

    const onClickHandler = ( e: any ) => {
        const { name, type } = e.target

        let value = e.target.value

        if ( type === 'checkbox' ) {
            value = getCheckedBoxes( name )
        }

        const map = e.target.dataset.map?.split( '|' )
        const inMap = map && (map.indexOf( value ) !== -1)
        store.setAnswer( name, value, inMap, inMap ? `${parentTitle} - ${s.title}` : '' )
    }

    return (
        <>
        { s.title?
        <div className="col-md-3 mt-3 mt-md-0 mb-0">
            <p><strong>{ s.title }</strong>  { s.subtitle?? ''} </p>
        </div>
        : '' }

        { runCallback(() => {
            const row = []
            for (let i = 0; i < s.repeat; i++) {
                row.push(
                    <div key={i} className="col-md-10 mt-2">
                        <div className="form-group">
                            <input
                                name={`${s.name}_${i}`}
                                className="form-control mr-sm-2"
                                data-type="array"
                                type={s.type}
                                placeholder={s.placeholder + ' ' + (i+1) }
                                onChange={onClickHandler}
                            />
                        </div>
                    </div>
                )
            }
            return row
        }) }

        {s.options?.map( (o: any) =>
            <div className="col-md-3 mt-sm-0 mb-3 mb-md-3" key={`${s.name}-${o}`}>
                <label>
                    <input
                        type={s.fieldType ?? 'checkbox'}
                        onClick={onClickHandler}
                        name={s.name ?? ''}
                        data-map={s.mapEnabled ?? ''}
                        value={o}
                    />
                    { o } {(s.mapEnabled && s.mapEnabled.split('|').indexOf(o) !== -1) ? '🚩' : ''}
                </label>
            </div>
        )}
        {s.options?.length === 2 ?
            <div className={"col-md-3 separacion2"}></div>
            :
            ''
        }
        </>
    )
}
export default QuestionSection;
